module.exports = __webpack_public_path__ + "static/media/lesson-finish1.82e149fe.png";